export const baseUrl = 'https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img'